export default {
    SAVE_SEARCH_PARAMS: 'HOSPITAL/DOCTORINFO/SAVE_SEARCH_PARAMS',
    UPDATE_DOCTOR: 'HOSPITAL/DOCTORINFO/UPDATE_DOCTOR',
}


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/store/constants.js